let basePopoverTempl = require('sma.common/components/partials/popover/base.mustache');

class Popover {
	constructor(options) {
		this.attachTo = options.attachTo;
		
		this.placement = options.placement || 'bottom';

		this.content = options.content || '';

		this.build();
	}

	get $content() {
		return this.element.find('sma-js-popover-content');
	}

	get visible() {
		return this.element.is(':visible');
	}

	build() {
		this.element = $(
			basePopoverTempl({
				placement: this.placement,
				content: this.content
			})
		).hide();

		this.element.find('.sma-js-popover-x').on('click', () => this.hide());
		
		this.attachTo.append(this.element);
	}

	changeContent(content) {
		this.content = content;
		this.$content.html(content);
	}

	show() {
		this.element.css('top', (this.attachTo.position().top + 10 + this.attachTo.outerHeight()) + 'px');
		this.element.css('left', (this.attachTo.position().left + (this.attachTo.outerWidth()/2.0) - (this.element.outerWidth() / 2.0)));
		this.element.fadeIn();
	}

	hide() {
		this.element.fadeOut();
	}

	toggle() {
		if (this.visible) {
			this.hide();
		} else {
			this.show();
		}
	}
}

module.exports = {
	Popover: Popover,
};
